import { render } from "./delay.vue?vue&type=template&id=3f6955d6"
import script from "./delay.vue?vue&type=script&lang=js"
export * from "./delay.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__